import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../routes'
import { TableRowBackground } from '../../../utils/colors'
import { useStyles } from './Styles'
import DeleteRole from './DeleteRole'

const RoleMenu = ({ index, data, setData, count, setCount, handleNotificationCall, adminSectionType }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewRoleMenu, setViewRoleMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewRoleMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewRoleMenu(false)
  }


  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))

  const [viewDeleteRoleDialog, setViewDeleteRoleDialog] = React.useState(false)
  const [openDeleteRoleDialog, setOpenDeleteRoleDialog] = React.useState(false)
  const handleDeleteRoleDialog = () => {
    if (!openDeleteRoleDialog) {
      setViewDeleteRoleDialog(true)
    } else {
      setTimeout(() => setViewDeleteRoleDialog(false), 500)
    }
    setOpenDeleteRoleDialog(!openDeleteRoleDialog)
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      {!!viewRoleMenu &&
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        className={classes.UserCustomMenu}
      >
        <MenuItem onClick={handleClose}>
          <NavLink to={formatRoute(NamedRoutes[adminSectionType].RolesAndPermissions.edit, { id: data[index].id })}>
            <FormattedMessage id='UserMenu.editPage'/>
          </NavLink>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Button color="primary" onClick={handleDeleteRoleDialog}>
            <FormattedMessage id='UserMenu.deletePage'/>
          </Button>
        </MenuItem>
      </StyledMenu>
      }
      <DeleteRole
        index={index}
        data={data}
        setData={setData}
        count={count}
        setCount={setCount}
        adminSectionType={adminSectionType}
        handleNotificationCall={handleNotificationCall}
        handleDeleteRoleDialog={handleDeleteRoleDialog}
        viewDeleteRoleDialog={viewDeleteRoleDialog}
        openDeleteRoleDialog={openDeleteRoleDialog}/>
    </div>
  )
}

export default RoleMenu
